import { TagAttribute } from '../../../types/TagAttribute';
import { InputSearch } from '../../Form/InputSearch';
import { FiTagIcon } from '../../Icon';
import { Tag } from '../../Tag/Tag';

import styles from './BlockSearchTermKeyword.module.scss';

import type { FC, ReactNode } from 'react';

export type Props = {
  children?: ReactNode;
  relatedTags?: TagAttribute[];
};

export const BlockSearchTermKeyword: FC<Props> = ({ relatedTags }) => (
  <div className={styles.wrap}>
    <h2 className={styles.title}>看護用語を検索</h2>
    <div className={styles['wrap-body']}>
      <InputSearch placeholder="気になる用語で検索" />

      {relatedTags ? (
        <>
          <h2 className={styles['title-sub']}>
            <FiTagIcon size={18} />
            関連するカテゴリー
          </h2>
          <Tag tagAttribute={relatedTags} />
        </>
      ) : (
        ''
      )}
    </div>
  </div>
);
